import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=49831d74&scoped=true&"
import script from "./ColorField.vue?vue&type=script&lang=ts&"
export * from "./ColorField.vue?vue&type=script&lang=ts&"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=49831d74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49831d74",
  null
  
)

export default component.exports